import { array, struct } from 'io-ts/Decoder';

import { Id } from '../../../job';

export const Request = struct({
	jobIds: array(Id),
});
